<template>
  <div>
    <div id="container" style="width:500px; height:300px"></div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        AMapUI: null,
        AMap: null,
        map: null,
        detail: {
          id: "",
          orderId: "",
          sfApiDetailId: "",
          receivePerson: "",
          receiveMobile: "",
          addressInfo: {
            addr: "",
            cityId: "",
            cityName: "",
            countyId: "",
            countyName: "",
            platformCode: "",
            provinceId: "",
            provinceName: "",
            receiveMobile: "",
            receivePerson: "",
            retCode: "",
            streetId: "",
            streetName: "",
          },
          orderLongi: "",
          orderLati: "",
          logisticsCode: "",
          status: "",
          deliveryStatus: "",
          deliveryCode: "",
          deliveryTime: "",
          deliveryDistance: "",
          deliveryPunchAddress: "",
          deliveryPunchLng: "",
          deliveryPunchLat: "",
          createtime: "",
          updatetime: "",
        },
      }
    },
    mounted: function () {

      this.init()
    },
    methods: {
      init: function () {
        this.$api.getOrderDeliveryDetail({id: 56411}).then((res) => {
          if (res.code == '200') {
            this.detail = res.data;
            this.detail.addressInfo = JSON.parse(res.data.addressInfo);

            let name = "";
            if (res.data.status == 0) name = "待处理";
            else if (res.data.status == 1) name = "处理中";
            else if (res.data.status == 200) name = "处理完成";
            else name = res.data.status;
            this.detail.status = name;

            let desc = "";
            if (res.data.deliveryStatus == 0) desc = "待处理";
            else if (res.data.deliveryStatus == -255) desc = "妥投异常";
            else if (res.data.deliveryStatus == 200) desc = "妥投成功";
            else desc = res.data.status;

            this.detail.deliveryStatus = desc;
            this.deliveryPoint.lng = res.data.deliveryPunchLng;
            this.deliveryPoint.lat = res.data.deliveryPunchLat;
            this.addrPoint.lng = res.data.orderLongi;
            this.addrPoint.lat = res.data.orderLati;
          }
        });

        let AMapUI = (this.AMapUI = window.AMapUI);
        let AMap = (this.AMap = window.AMap);
        this.AMapUI = AMapUI;
        this.AMap = AMap;
        this.AMapUI.loadUI(["misc/PositionPicker"], PositionPicker => {
          let mapConfig = {
            zoom: 20,
            center: [102.77627, 24.936198],
            resizeEnable: true,
          };
          let map = new this.AMap.Map("container", mapConfig);
          this.map = map;
          this.AMap.plugin(["AMap.ToolBar", "AMap.Scale", "AMap.MapType"], function () {
            map.addControl(new AMap.ToolBar({}));
            map.addControl(new AMap.Scale({}));
            map.addControl(new AMap.MapType({}));
          });

          let lnglats = [
            [102.776512, 24.936761],
            [102.77627, 24.936198]
          ];

          let infoWindow = new this.AMap.InfoWindow({offset: new this.AMap.Pixel(0, -30)});
          for (let i = 0, marker; i < lnglats.length; i++) {
            let marker = new AMap.Marker({
              position: lnglats[i],
              map: map
            });

            let info = [];
            info.push("<p class='input-item'>第几个" + (i + 1) + " Marker</p>");
            info.push("<p class='input-item'>地址 :北京市朝阳区望京阜荣街10号首开广场4层</p></div></div>");
            infoWindow.setContent(info.join(""))
            infoWindow.setAnchor("bottom-right")
            infoWindow.open(map, marker.getPosition());

            //鼠标点击marker弹出自定义的信息窗体
            this.AMap.event.addListener(marker, 'click', function () {
              infoWindow.setContent(info.join(""))
              infoWindow.setAnchor("bottom-right")
              infoWindow.open(map, marker.getPosition());
            });
          }
          map.add(marker);
        });
      },
    }
  }
</script>
<style>
</style>

<!--<template>-->
<!--  <div id="app">-->
<!--    <div class="amap-page-container">-->
<!--      <el-amap-->
<!--        vid="amapDemo"-->
<!--        :center="center"-->
<!--        :zoom="zoom"-->
<!--        :plugin="plugin"-->
<!--        class="amap-demo"-->
<!--        :events="events">-->
<!--        <el-amap-marker-->
<!--          v-for="(marker,index) in markers"-->
<!--          :key="index"-->
<!--          :events="marker.events"-->
<!--          :position="marker.position"-->
<!--        />-->
<!--        <el-amap-info-window-->
<!--          v-if="window"-->
<!--          :position="window.position"-->
<!--          :visible="window.visible"-->
<!--          :content="window.content"-->
<!--          :offset="window.offset"-->
<!--          :close-when-click-map="true"-->
<!--          :is-custom="true"-->
<!--        >-->
<!--          <div id="info-window">-->
<!--            <p>{{ window.address }}</p>-->
<!--          </div>-->
<!--        </el-amap-info-window>-->
<!--      </el-amap>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--  export default {-->
<!--    name: "AmapPage",-->
<!--    data: function () {-->
<!--      const self = this;-->
<!--      return {-->
<!--        data: [-->
<!--          {-->
<!--            position: "102.776512, 24.936761",-->
<!--            address: "另一个地址",-->
<!--          },-->
<!--          {-->
<!--            position: "102.77627,24.936198",-->
<!--            address: "一个地址",-->
<!--          },-->
<!--        ],-->
<!--        zoom: 20,-->
<!--        center: [102.77627, 24.936198],-->
<!--        markers: [],-->
<!--        windows: [],-->
<!--        window: "",-->
<!--        /*一些工具插件*/-->
<!--        plugin: [{-->
<!--          // pName为必填字段-->
<!--          pName: 'AMap.Scale',-->
<!--          defaultType: 1-->
<!--        }, {-->
<!--          pName: "AMap.ToolBar",-->
<!--          useNative: true,-->
<!--        }],-->
<!--      };-->
<!--    },-->
<!--    mounted() {-->
<!--      this.point();-->
<!--    },-->
<!--    methods: {-->
<!--      point() {-->
<!--        const markers = [];-->
<!--        const windows = [];-->
<!--        const that = this;-->
<!--        this.data.forEach((item, index) => {-->
<!--          markers.push({-->
<!--            position: item.position.split(","),-->
<!--            // icon:item.url, //不设置默认蓝色水滴-->
<!--            events: {-->
<!--              click() {-->
<!--                // 方法：鼠标移动到点标记上，显示相应窗体-->
<!--                that.windows.forEach((window) => {-->
<!--                  window.visible = false; // 关闭窗体-->
<!--                });-->
<!--                that.window = that.windows[index];-->
<!--                that.$nextTick(() => {-->
<!--                  that.window.visible = true;-->
<!--                });-->
<!--              },-->
<!--            },-->
<!--          });-->
<!--          windows.push({-->
<!--            position: item.position.split(","),-->
<!--            isCustom: true,-->
<!--            offset: [115, 55], // 窗体偏移-->
<!--            showShadow: false,-->
<!--            visible: false, // 初始是否显示-->
<!--            address: item.address,-->
<!--          });-->
<!--        });-->
<!--        //  加点-->
<!--        this.markers = markers;-->
<!--        // 加弹窗-->
<!--        this.windows = windows;-->
<!--      },-->
<!--      checkDetail() {-->
<!--        alert("点击了查看详情");-->
<!--      },-->
<!--    },-->
<!--  };-->
<!--</script>-->

<!--<style scoped>-->
<!--  .amap-demo {-->
<!--    height: 120vh;-->
<!--  }-->

<!--  .amap-page-container {-->
<!--    position: relative;-->
<!--  }-->

<!--  #info-window {-->
<!--    width: 211px;-->
<!--    height: 100px;-->
<!--    margin-left: 30px;-->
<!--    padding: 10px 10px 10px 10px;-->
<!--    background: white;-->
<!--    border-radius: 4px;-->
<!--    position: relative;-->
<!--    overflow: hidden;-->
<!--  }-->

<!--  /*.detail {*/-->
<!--  /*  width: 100%;*/-->
<!--  /*  height: 24px;*/-->
<!--  /*  color: #fff;*/-->
<!--  /*  background-color: #1a73e8;*/-->
<!--  /*  position: absolute;*/-->
<!--  /*  bottom: 0;*/-->
<!--  /*  font-size: 12px;*/-->
<!--  /*  line-height: 24px;*/-->
<!--  /*  text-align: center;*/-->
<!--  /*  cursor: pointer;*/-->
<!--  /*}*/-->
<!--</style>-->



// WEBPACK FOOTER //
// src/views/order/orderMap.vue